<template>
    <div>
        <label class="block text-sm font-medium text-gray-700">Status</label>
        <select-menu v-model="local"
                     :text="text"
                     :values="values">
        </select-menu>
    </div>
</template>
<script>
import SelectMenu from "./UI/SelectMenu.vue";

export default {
    name: 'desk-status',
    components: {SelectMenu},

    data: () => ({

        values: [null, 'disabled'],
        text: ['alle', 'gesperrt'],
    }),

    computed: {
        local: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value !== "" ? value : null);
            },
        },
    }
}
</script>